import { Pencil } from "lucide-react";
import { AddressMap } from "@/components/common/AddressMap";

type Props = {
  contactAddressLines: string[];
  companyAddressLines: string[];
  mapAddressLines: string[];
  apiKey: string | null;
  isMandatory: boolean;
  isReadOnly: boolean;
  onEditClick: () => void;
};

export const ContactAddressPanel = ({
  contactAddressLines,
  companyAddressLines,
  mapAddressLines,
  apiKey,
  isMandatory,
  isReadOnly,
  onEditClick,
}: Props) => {
  const addressesDiffer = contactAddressLines.join() !== companyAddressLines.join();

  return (
    <div className="px-5 py-4 flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-normal text-gray-400 uppercase tracking-wider">
          Address{isMandatory && <span className="text-red-500 ml-0.5">*</span>}
        </span>
        {!isReadOnly && (
          <button
            type="button"
            title="Edit address"
            className="p-0.5 text-muted-foreground hover:text-blue-600 transition-colors"
            onClick={onEditClick}
          >
            <Pencil size={13} />
          </button>
        )}
      </div>

      {contactAddressLines.length > 0 ? (
        <div className="grid grid-cols-2 gap-x-4">
          <div>
            <span className="text-[11px] font-normal text-gray-400 uppercase tracking-wider">Contact</span>
            <address className="not-italic text-[15px] text-gray-800 leading-snug mt-0.5">
              {contactAddressLines.map((line, i) => <span key={i} className="block">{line}</span>)}
            </address>
          </div>
          {companyAddressLines.length > 0 && addressesDiffer && (
            <div>
              <span className="text-[11px] font-normal text-gray-400 uppercase tracking-wider">Company</span>
              <address className="not-italic text-[15px] text-gray-500 leading-snug mt-0.5">
                {companyAddressLines.map((line, i) => <span key={i} className="block">{line}</span>)}
              </address>
            </div>
          )}
        </div>
      ) : companyAddressLines.length > 0 ? (
        <address className="not-italic text-[15px] text-gray-800 leading-snug">
          {companyAddressLines.map((line, i) => <span key={i} className="block">{line}</span>)}
        </address>
      ) : (
        <div>
          <span className="text-[11px] font-normal text-gray-400 uppercase tracking-wider">Contact</span>
          <p className="text-sm text-muted-foreground italic mt-0.5">No address on record</p>
        </div>
      )}

      <AddressMap addressLines={mapAddressLines} apiKey={apiKey} />
    </div>
  );
};
